import { render } from "./OrderDetails.vue?vue&type=template&id=6f86b128&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"

import "./OrderDetails.vue?vue&type=style&index=0&id=6f86b128&scoped=true&lang=less"

import exportComponent from "E:\\case\\要点传达商城\\6-5\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f86b128"]])

export default __exports__